export const CANCEL_REASONS_RESET_STATE = 'CANCEL_REASONS_RESET_STATE';
export const CANCEL_REASONS_CURRENT_ITEM = 'CANCEL_REASONS_CURRENT_ITEM';

export const CANCEL_REASONS_REQUEST_LOADING = 'CANCEL_REASONS_REQUEST_LOADING';
export const CANCEL_REASONS_REQUEST_SUCCESS = 'CANCEL_REASONS_REQUEST_SUCCESS';
export const CANCEL_REASONS_REQUEST_FAILED = 'CANCEL_REASONS_REQUEST_FAILED';

export const CANCEL_REASONS_CURRENT_ACTION = 'CANCEL_REASONS_CURRENT_ACTION';
export const CANCEL_REASONS_RESET_ACTION = 'CANCEL_REASONS_RESET_ACTION';